import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.action': {
    flex: 3,
    'max-width': '324px',
  },
  '.active': {
    flex: 3,
    'max-width': '324px',
  },
  '.data-box': {
    background: 'var(--abyss-colors-error2)',
    border: '1px solid var(--abyss-colors-error1)',
    borderRadius: '4px',
    padding: '20px 12px',
  },
  '.item': {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  '.list': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-around',
  },
  '.total': {
    flex: 2,
    'max-width': '212px',
  },
  '.wrap': {
    alignItems: 'stretch',
    display: 'flex',
    gap: '24px',
  },
  h4: {
    color: 'var(--abyss-colors-black) !important',
  },
});
